import './Benefit.css';

const text = 'БОНУСЫ';
export const Benefit = () => {
    return (
        <div className="header__benefit">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24">
                <g fill="none" opacity=".6">
                    <path fill="#605F68" d="M5.665 19.84h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3h-14a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3z" />
                    <path
                        fill="#F1F1F1"
                        d="m13.765 7.524.558 1.13c.18.362.524.613.924.671l1.247.181c1.007.146 1.408 1.383.68 2.093l-.902.88a1.228 1.228 0 0 0-.353 1.086l.213 1.242c.172 1.002-.88 1.767-1.78 1.294l-1.116-.586a1.227 1.227 0 0 0-1.142 0l-1.115.586c-.9.473-1.952-.291-1.78-1.294l.212-1.242a1.228 1.228 0 0 0-.353-1.086l-.902-.88c-.728-.71-.326-1.947.68-2.093l1.247-.181c.4-.058.745-.309.924-.671l.558-1.13c.45-.912 1.75-.912 2.2 0z"
                    />
                </g>
            </svg>
            <span className="header__benefit-text">{text}</span>
        </div>
    );
};
